import {Component, OnDestroy, ViewChild} from '@angular/core';
import {Subject, takeUntil} from "rxjs";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {
  FetchParticipantsWeightListRequest
} from '../../../core/group-dashboard.actions';
import {participantsWeightList} from '../../../core/group-dashboard.selector';
import {
  roles,
  statusLabelMap,
  userStatusMap
} from '../../../../../shared/constants/common.constants';
import {CommonService} from '../../../../../shared/services/common.service';
import {ActivatedRoute, Router} from '@angular/router';
import {
  ParticipantAndCaregiver
} from '../../../../../../models/participantAndCaregiver';
import {
  ParticipantsWeightList
} from '../../../../../../models/participants-weight-list';
import {GroupDashboardService} from '../../../services/group-dashboard.service';
import {drillDownUrls} from "../../../../../shared/core/shared.selectors";
import {SetDrillDownUrls} from "../../../../../shared/core/shared.actions";
import {MatTable, MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";

@Component({
  selector: 'app-participant-weight-information-table',
  templateUrl: './participant-weight-information-table.component.html',
  styleUrls: ['./participant-weight-information-table.component.css']
})
export class ParticipantWeightInformationTableComponent implements OnDestroy {
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(MatSort) sort: MatSort;
  tableData: any[];
  dataSource: any = new MatTableDataSource();
  sortColumn: any;
  sortOrder: any;
  isFirstPage = true;

  selectedUserRole: number | null;
  loading: boolean = false;
  typeMap = {
    4: 'Adult',
    5: 'Participant',
  };
  participantCaregiverList: ParticipantsWeightList;
  displayedColumns = [
    'name',
    'currentWeight',
    'weightChange',
    'weightLossAlert',
    'currentBMI',
    'changeBMI'
  ];

  participantOnlyColumns = [
    'currentMedianBMI',
    'changeMedianBMI',
    'currentOverPercentile',
    'changeOverPercentile'
  ]
  protected readonly clinicStatusLabelMap = statusLabelMap;
  protected readonly userStatusMap = userStatusMap;
  private readonly OnDestroy: Subject<any> = new Subject<any>();
  private participantWeightFilters: {
    clientId?: number[],
    groupId?: number[],
    session?: number,
    status?: number[],
    searchText?: string,
  } = null;
  private groupId: number;

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private groupDashboardService: GroupDashboardService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.groupId = +this.route.snapshot.paramMap.get('groupId');

    this.store.select(participantsWeightList)
      .pipe(takeUntil(this.OnDestroy))
      .subscribe(data => {
        this.loading = data.loading;
        this.participantCaregiverList = data;


        if (!data.loading) {
          this.dataSource.data = [...data.list];

          if (data.hasNext) {
            setTimeout(() => {
              if (this.sortColumn && data.pageNumber === 1) {
                this.commonService.scrollColumnInView(this.sortColumn);
              }
            }, 0)

            setTimeout(() => {
              // check window height for infinite scroll
              this.commonService.checkInfiniteScrollHeightAndCallNext('table-wrapper', () => {
                this.onScroll();
              });
            }, 0)
          }
        }
      });

    // listen for filter changes from the filter component
    this.groupDashboardService.onParticipantWeightInformationFilterChange.pipe(takeUntil(this.OnDestroy))
      .subscribe((filters) => {
        this.participantWeightFilters = filters;
        this.isFirstPage = true;
        this.displayedColumns = this.displayedColumns.filter(column => !this.participantOnlyColumns.includes(column));

        if (filters['role']?.length && filters['role'].includes(roles.participant)) {
          this.displayedColumns = [
            ...this.displayedColumns,
            ...this.participantOnlyColumns
          ]
        }
        this.participantWeightFilters = filters;
        this.fetchParticipantWeightList();
      })
  }

  ngOnInit() {

  }

  fetchParticipantWeightList(pageNumber = 1, limit = 10) {
    this.store.dispatch(FetchParticipantsWeightListRequest({
      payload: {
        ...this.participantWeightFilters,
        ...(this.groupId ? {groupId: this.groupId} : {}),
        pageNumber,
        limit,
      }
    }));
  }

  onScroll() {
    if (this.participantCaregiverList?.hasNext && !this.participantCaregiverList?.loading) {
      this.fetchParticipantWeightList(this.participantCaregiverList.pageNumber + 1, this.participantCaregiverList.limit);
      this.isFirstPage = false;
    }
  }

  openUserDetails(user: ParticipantAndCaregiver) {
    if (user?.id) {
      this.store.select(drillDownUrls).subscribe(data => {
        const updatedDrillDownUrls = [...data, this.router.url];
        if ([...data].pop() !== this.router.url) {
          this.store.dispatch(SetDrillDownUrls({payload: updatedDrillDownUrls}));
        }
      }).unsubscribe();
      const urlPrefix = this.router.url.split('/')[1];
      this.router.navigate([`/${urlPrefix}/member/${user.id}/behavior-tracker`]);
    }
  }

  ngOnDestroy() {
    this.OnDestroy.next(null);
    this.OnDestroy.complete();
  }
}
